import React, { useState } from "react";
import dayjs from 'dayjs';
function FinancialYear({ onInputChange, namemain, defaultValuemain }){
    const today = new Date();

    const [value, setValue] = useState(sessionStorage.getItem("CurrentFinancialYear") === null ? String(today.getFullYear()) : String(sessionStorage.getItem("CurrentFinancialYear")));
    
  
    return (

          <select
                className="form-control form-select"
                  name={namemain}
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value);
                    onInputChange(e);
                  }}>

            {value === "none" && <option value="none">{defaultValuemain === "" || defaultValuemain === null ? "Select A Financial Year" : defaultValuemain}</option>}
              <option value="2022"> 2022-2023</option>
            <option value="2023"> 2023-2024</option>
            <option value="2024"> 2024-2025</option>
            <option value="2025"> 2025-2026</option>
            <option value="2026"> 2026-2027</option>
               
              </select>
   
     

         
  );
};

export default FinancialYear;
